import { api } from '../api/client';
import type { PersonalChannels } from './channels-api';
import { currentEndpoint, unsubscribePush } from './push';

/**
 * Switches push off for this device at sign-out, so a shared device gets no notices for the
 * previous person: the server forgets the device and the browser ends the subscription. Never
 * stops the sign-out; if the server cannot be reached, the push service drops the ended
 * subscription and the next message removes it there.
 */
export async function forgetPushDevice(): Promise<void> {
  const endpoint = await currentEndpoint().catch(() => null);
  if (!endpoint) return;
  try {
    const channels = await api.get<PersonalChannels>('/notifications/channels');
    const device = channels.push.devices.find((entry) => entry.endpoint === endpoint);
    if (device) await api.delete(`/notifications/channels/push/${device.id}`);
  } catch {
    // Offline or the session already ended.
  }
  await unsubscribePush().catch(() => undefined);
}
